import React, { useState } from "react";
import { showErrorToast, showPromiseToast } from "../../services/toastService.js";
import { deleteMySyb, newSub } from "../../services/subsService.js";

export default function SubscribeCard() {
	const [email, setEmail] = useState("");

	const isValidEmail = (email) => {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return emailRegex.test(email);
	};

	const handleSubscribeButton = () => {
		if (isValidEmail(email)) {
			showPromiseToast(newSub(email), {
				pending: "Iscrizione in corso...",
				success: "Iscrizione completata!",
			}).finally(() => setEmail(""));
		} else showErrorToast("Inserisci un'email valida.");
	};

	const handleUnubscribeButton = () => {
		if (isValidEmail(email)) {
			showPromiseToast(deleteMySyb(email), {
				pending: "Operazione in corso...",
				success: "Iscrizione eliminata!",
			}).finally(() => setEmail(""));
		} else showErrorToast("Inserisci un'email valida.");
	};

	return (
		<div className="w-full h-full">
			<h3 className="text-xl font-semibold text-gray-800 mb-4 text-center">
				Resta aggiornato!
			</h3>
			<p className="text-md text-gray-600 mb-4 text-center">
				Lascia la tua email per ricevere aggiornamenti sulle allerte in tempo reale.
			</p>
			<div className="flex flex-col space-y-4">
				{/* Campo email */}
				<input
					type="text"
					value={email}
					onChange={(e) => setEmail(e.target.value)}
					placeholder="Inserisci la tua email"
					className="p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
					required
				/>
				{/* Testo di consenso */}
				<p className="text-xs text-gray-600">
					Cliccando sul pulsante <strong>Iscriviti</strong>, acconsenti all'archiviazione
					dei dati forniti per gli scopi indicati.
				</p>
				{/* Pulsante invio */}
				<button
					id="subscribe"
					aria-label="Iscriviti"
					className="p-2 bg-blue-700 text-white rounded-md hover:bg-blue-800 transition"
					onClick={handleSubscribeButton}
				>
					Iscriviti
				</button>
				<p className="text-xs text-gray-600">
					Per eliminare la tua iscrizione e non ricevere più comunicazioni, inserisci la
					tua mail e clicca nel pulsante sottostante
				</p>
				<button
					id="deleteSub"
					aria-label="Annulla iscrizione"
					className="p-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-300 transition"
					onClick={handleUnubscribeButton}
				>
					Elimina la tua iscrizione
				</button>
			</div>
		</div>
	);
}
